// extracted by mini-css-extract-plugin
export default {"amountWrapper":"ServiceProperties_amountWrapper--HAo","typeLabel":"ServiceProperties_typeLabel--xTm"};